export enum VizType {
  Plot = 'plot',
  Table = 'table',
  Treemap = 'treemap',
  Image = 'image',
  Select = 'select',
  GenomicSequence = 'genomic_sequence',
  Content = 'content',
  ColorscaledImage = 'colorscaled_image',
  Node = 'node'
}
